import React from "react";
import MenuNavbar from '../function-components/MenuNavbar'
import Floaticons from '../function-components/Floaticons'

function EcoSystem() {
    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <Floaticons />
            <h2 style={{ textAlign: "center" }}>Comming Soon!!!</h2>
        </>
    );
}

export default EcoSystem;
